/* eslint-disable */
import React, { useEffect, useState } from "react";
const RequirementField = ({
    label,
    name,
    placeholder,
    register,
    errors,
    setValue,
    requirements,
    setRequirements,
}) => {

    const [inputValue, setInputValue] = useState('');
    const handleAddRequirement = () => {
        if (inputValue.trim() !== "") {
            setRequirements([...requirements, inputValue]);
            setInputValue('');
        }
    };
    const handleOnChange = (event) => {
        setInputValue(event.target.value);
    }
    const onEnterHandler = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            setInputValue(event.target.value.trim());
            handleAddRequirement();
        }
    }
    const handleDeleteRequirement = (index) => {
        const updatedRequirements = requirements.filter((_, i) => i !== index);
        setRequirements(updatedRequirements);
    };
    useEffect(() => {
        setValue(name, requirements);
    }, [requirements, name, setValue]);

    return (
        <div className="requirement-field">
            <label htmlFor="justForInputRequirments" className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>{label} <sup className='text-pink-200'>*</sup></label>
            <input
                className="hidden"
                name={name}
                {...register(name, { required: true })}
            />
            <input
                className='w-full p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 outline-none'
                style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                type="text"
                id="justForInputRequirments"
                name='justForInputRequirments'
                placeholder={placeholder}
                value={inputValue}
                onChange={handleOnChange}
                onKeyDown={onEnterHandler}
            />
            {errors[name] && <span className='text-pink-200 text-sm'>at least one requirement is required</span>}
            <button
                className="font-bold text-yellow-50 m-1"
                type="button"
                onClick={handleAddRequirement}
            >
                Add
            </button>
            <div>
                {requirements.map((requirement, index) => (
                    <div key={index} className="w-fit m-1 flex items-center gap-x-2 cursor-default">
                        {requirement}
                        <button
                            type="button"
                            className="text-[0.7rem] cursor-pointer text-richblack-300"
                            onClick={() => handleDeleteRequirement(index)}
                        >
                            remove
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RequirementField;